module.exports = __webpack_public_path__ + "img/first-day-8.211a7403.webp";